import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.792 23.698a4.94 4.94 0 0 1-4.177-2.313 4.9 4.9 0 0 1-.771-2.531 4.9 4.9 0 0 1 1.77-3.896 5.02 5.02 0 0 1 3.063-1.156c1.354-.01 2.573.458 3.531 1.375a4.87 4.87 0 0 1 1.521 3.469 4.85 4.85 0 0 1-.666 2.573c-.25.437-.573.843-.959 1.187a4.82 4.82 0 0 1-3.218 1.292zm0-8.333h-.073a3.4 3.4 0 0 0-2.104.791 3.35 3.35 0 0 0-1.209 2.667c.01.614.198 1.219.521 1.729.636 1.02 1.74 1.646 2.927 1.583a3.34 3.34 0 0 0 2.198-.885c.271-.24.49-.51.656-.802a3.4 3.4 0 0 0 .459-1.76 3.36 3.36 0 0 0-1.042-2.376 3.3 3.3 0 0 0-2.333-.948"
      fill="#292D32"
    />
    <path
      d="M19.219 20.573a.78.78 0 0 1-.542-.219l-1.052-1a.777.777 0 0 1-.021-1.104.777.777 0 0 1 1.104-.02l.51.489 1.636-1.584a.777.777 0 0 1 1.104.021.777.777 0 0 1-.02 1.104l-2.178 2.104a.84.84 0 0 1-.541.209M12.5 13.854a.8.8 0 0 1-.396-.104L2.906 8.427a.783.783 0 0 1-.281-1.073.773.773 0 0 1 1.062-.281l8.802 5.093 8.75-5.062a.78.78 0 0 1 1.063.281.79.79 0 0 1-.281 1.073l-9.136 5.292a.8.8 0 0 1-.385.104"
      fill="#292D32"
    />
    <path
      d="M12.5 23.291a.787.787 0 0 1-.781-.78v-9.449c0-.427.354-.781.781-.781s.781.354.781.781v9.448a.787.787 0 0 1-.781.781"
      fill="#292D32"
    />
    <path
      d="M12.5 23.698c-.917 0-1.834-.198-2.542-.604L4.396 20.01c-1.51-.833-2.698-2.843-2.698-4.573V9.542c0-1.73 1.187-3.73 2.698-4.573l5.562-3.084c1.417-.802 3.646-.802 5.073 0l5.563 3.084c1.51.833 2.697 2.843 2.697 4.573v5.895c0 .105 0 .188-.02.292-.052.27-.25.5-.51.583a.8.8 0 0 1-.772-.145c-1.198-1.042-3.052-1.084-4.312-.073a3.36 3.36 0 0 0-.781 4.375c.083.145.166.26.26.375a.77.77 0 0 1-.219 1.187l-1.906 1.052c-.708.417-1.615.615-2.531.615m0-20.834c-.646 0-1.302.136-1.771.396L5.166 6.344c-1.01.552-1.885 2.052-1.885 3.198v5.895c0 1.146.885 2.646 1.885 3.198l5.563 3.084c.948.53 2.604.53 3.552 0l1.167-.646a4.9 4.9 0 0 1-.594-2.344c0-1.52.677-2.927 1.854-3.864 1.417-1.136 3.438-1.376 5.031-.699V9.522c0-1.146-.885-2.646-1.885-3.198L14.292 3.24c-.49-.24-1.146-.375-1.792-.375"
      fill="#292D32"
    />
  </svg>
);
export default SVGComponent;
